import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ScheduleIcon from "@mui/icons-material/Schedule";
import FinancialYearAndMonthSelector from "views/atom-pro/Gstr/modules/Compliance/YearPeriodSelect";
import { getGstFinancialYears } from "utils/FinancialYears";
import React, { useState } from "react";
import { snack } from "components/toast";
import { getCurrentFormattedDateTime } from "utils";
import { exportGstClientReport } from "api/services/clients/gstr-clients";
import { getGstrProfile } from "api/services/gstr/gstr";
import { ResType } from "types";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
const reports = [
  {
    title: "GSTR-1 Detailed Report",
    date: "15 Mar 2018",
    time: "04:22 PM",
    status: "pending",
    type: "GSTR1",
  },
  {
    title: "GSTR-2A Detailed Report",
    date: "14 Mar 2018",
    time: "02:10 PM",
    status: "pending",
    type: "GSTR2A",
  },
  {
    title: "GSTR-2B Detailed Report",
    date: "Introduced from FY 2020-21",
    status: "pending",
    type: "GSTR2B",
  },
  {
    title: "GSTR-3B Summary Report",
    date: "10 Mar 2018",
    time: "11:05 AM",
    status: "pending",
    type: "GSTR3B",
  },
  {
    title: "GSTR-9 Summary Report",
    date: "10 Mar 2018",
    time: "11:05 AM",
    status: "pending",
    type: "GSTR9",
  },
  {
    title: "Tax Liability & ITC Compare",
    date: "Never generated",
    status: "generated",
    type: "TAXLIBIT",
  },
  // {
  //   title: "GSTR-9C Summary Report",
  //   date: "10 Mar 2018",
  //   time: "11:05 AM",
  //   status: "pending",
  //   type: "GSTR9C",
  // },

];

const GstReportsDetails = ({ gstrId }: { gstrId?: string | number } = {}) => {
  const financialYears = getGstFinancialYears();
  const [selectedYear, setSelectedYear] = React.useState(financialYears[0]);
  const params = useParams();
  const effectiveGstrId = gstrId ?? params.gstrid;
  const [repostexporting, setReportExporting] = useState(false);
  const { data: clientdata }: ResType = useQuery(["gstr-profile", effectiveGstrId], getGstrProfile, {

  });
  const clientName = clientdata?.data?.gstrProfile?.legalName;
  const taxType = clientdata?.data?.gstrProfile?.taxType;
  const [showGeneratingDialog, setShowGeneratingDialog] = useState(false);

  const handleGstClientReportExport = async (type: string) => {
    try {
      setReportExporting(true);
      setShowGeneratingDialog(true);

      const payload = {
        financialYear: selectedYear,
        clientId: clientdata?.data?.gstrProfile?.clientId,
        type,
      };

      console.log({
        financialYear: selectedYear,
        clientId: clientdata?.data?.gstrProfile?.id,
        type,
      });

      // Allow dialog to render before starting API call
      await new Promise((resolve) => setTimeout(resolve, 100));

      const res = await exportGstClientReport(payload);

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileURL = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = fileURL;

      const clientDisplayName = clientName;

      const safeClientName = clientDisplayName
        ? clientDisplayName.replace(/[\\/:*?"<>|]/g, "")
        : "Client";

      const formattedDateTime = getCurrentFormattedDateTime();

      link.download = `ATOM Pro - (${safeClientName}) ${type} - ${selectedYear} - Report ${formattedDateTime}.xlsx`;

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(fileURL);

      snack.success("Report generated successfully");
    } catch (error: any) {
      console.log("FULL ERROR", error);

      let message = "Failed to export GST report";

      if (error?.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const json = JSON.parse(text);

          message = json?.message || message;
        } catch (e) {
          console.error("Failed to parse blob error", e);
        }
      } else {
        message =
          error?.response?.data?.message ||
          error?.message ||
          message;
      }

      snack.error(message);
    } finally {
      setShowGeneratingDialog(false);
      setReportExporting(false);
    }
  };
  if (taxType !== "Regular") {
    return (
      <Box justifyContent="center" display="flex" alignItems="center" mt={20}>
        NO DATA
      </Box>
    );
  }
  return (
    <Box p={2}>
      <Box display="flex" justifyContent="space-between" alignItems="center" gap={1} mb={2}>
        <Box display="flex" alignItems="center" justifyContent="flex-end" gap={2}>
          {/* <Typography
            variant="subtitle1"
            fontWeight={700}
            color="#64748b"
          >
            DETAILED REPORTS
          </Typography>

          <Chip
            label={reports.length}
            size="small"
            sx={{
              height: 22,
              fontWeight: 600,
            }}
          /> */}
        </Box>
        <Box display="flex" justifyContent="flex-end">
          <FinancialYearAndMonthSelector
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
          />

        </Box>
      </Box>


      <Grid container spacing={2}>
        {reports.map((item) => (
          <Grid item xs={12} md={6} lg={4} key={item.title}>
            <Paper
              elevation={0}
              sx={{
                p: 2,
                border: "2px solid #b9b9ba", // darker border
                borderRadius: 2,
                position: "relative",
                minHeight: 135,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                cursor: "pointer",
                transition: "all 0.14s ease",

                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: -1,
                  top: 0,
                  bottom: 0,
                  width: 6,
                  borderRadius: "8px 0 0 8px",
                  // background:
                  //   item.status === "generated"
                  //     ? "#16a34a"
                  //     : "#d1d5db",
                  background:
                    item.status === "generated"
                      ? "#7945bd"
                      : "#16a34a",
                },

                "&:hover": {
                  borderColor: "#bfdbfe",
                  boxShadow:
                    "0 4px 12px rgba(0,0,0,0.08), 0 2px 4px rgba(0,0,0,0.05)",
                  transform: "translateY(-1px)",
                },
              }}
            >
              <Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="flex-start"
                >
                  <Typography
                    fontWeight={600}
                    fontSize={18}
                  >
                    {item.title}
                  </Typography>

                  {/* {item.status === "generated" && (
                    <Chip
                      label="✓ Generated"
                      color="success"
                      size="small"
                    />
                  )} */}

                  {/* {item.status === "unavailable" && (
                    <Chip
                      label="Not Available"
                      size="small"
                    />
                  )} */}

                  {/* {item.status === "pending" && (
                    <Chip
                      label="Not Generated"
                      size="small"
                    />
                  )} */}
                </Box>

                {/* <Box
                  mt={1}
                  display="flex"
                  alignItems="center"
                  gap={0.5}
                >
                  <ScheduleIcon
                    sx={{
                      fontSize: 16,
                      color: "#94a3b8",
                    }}
                  />
                   <Typography
                    variant="body2"
                    color="#94a3b8"
                  >
                    {item.time
                      ? `${item.date}  ${item.time}`
                      : item.date}
                  </Typography> 
                </Box> */}
              </Box>

              <Box
                display="flex"
                justifyContent="flex-end"
                gap={1}
                mt={2}
              >
                {/* {item.status === "generated" && (
                  <>
                    <Button
                      size="small"
                      color="success"
                      variant="outlined"
                      startIcon={<DownloadIcon />}
                    >
                      Download
                    </Button>

                    <Button
                      size="small"
                      variant="outlined"
                      startIcon={<AutorenewIcon />}
                    >
                      Regenerate
                    </Button>
                  </>
                )} */}


                <Button
                  size="small"
                  startIcon={<PlayArrowIcon />}
                  onClick={() => handleGstClientReportExport(item.type)}
                  disabled={repostexporting}
                  sx={{
                    backgroundColor: "#eff6ff",
                    color: "#2563eb",
                    border: "1px solid #93c5fd",
                    textTransform: "none",
                    fontWeight: 500,
                    boxShadow: "none",
                    "&:hover": {
                      backgroundColor: "#dbeafe",
                      borderColor: "#68aefd",
                      boxShadow: "none",
                    },
                  }}
                >
                  Generate Now
                </Button>


                {/* {item.status === "unavailable" && (
                  <Button size="small" disabled>
                    N/A for this FY
                  </Button>
                )} */}
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
      <Dialog
        open={showGeneratingDialog}
        disableEscapeKeyDown
      >
        <DialogContent
          sx={{
            textAlign: "center",
            py: 4,
            minWidth: 320,
          }}
        >
          <CircularProgress />

          <Typography mt={2} fontWeight={600}>
            Generating Report
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
            mt={1}
          >
            Please wait while we generate your GST report...
          </Typography>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default GstReportsDetails;